// source: acompanha/subscription_plans/v1/subscription_plans.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.SubscriptionPlan', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_plans.v1.SubscriptionPlan.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.SubscriptionPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.SubscriptionPlan.displayName = 'proto.acompanha.subscription_plans.v1.SubscriptionPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.displayName = 'proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.displayName = 'proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.displayName = 'proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.displayName = 'proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.displayName = 'proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.displayName = 'proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.displayName = 'proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.displayName = 'proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.displayName = 'proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.SubscriptionPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
monthlyBilledValue: jspb.Message.getFieldWithDefault(msg, 4, 0),
featuresList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
limitsList: jspb.Message.toObjectList(msg.getLimitsList(),
    acompanha_common_v1_common_pb.PlanLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.SubscriptionPlan;
  return proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyBilledValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeatures(value);
      break;
    case 6:
      var value = new acompanha_common_v1_common_pb.PlanLimit;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanLimit.deserializeBinaryFromReader);
      msg.addLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.SubscriptionPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMonthlyBilledValue();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getLimitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      acompanha_common_v1_common_pb.PlanLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 monthly_billed_value = 4;
 * @return {number}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.getMonthlyBilledValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.setMonthlyBilledValue = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string features = 5;
 * @return {!Array<string>}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.getFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.setFeaturesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.addFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.clearFeaturesList = function() {
  return this.setFeaturesList([]);
};


/**
 * repeated acompanha.common.v1.PlanLimit limits = 6;
 * @return {!Array<!proto.acompanha.common.v1.PlanLimit>}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.getLimitsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PlanLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PlanLimit, 6));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PlanLimit>} value
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
*/
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.setLimitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.acompanha.common.v1.PlanLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PlanLimit}
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.addLimits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.acompanha.common.v1.PlanLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan} returns this
 */
proto.acompanha.subscription_plans.v1.SubscriptionPlan.prototype.clearLimitsList = function() {
  return this.setLimitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest;
  return proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.subscription_plans.v1.SubscriptionPlan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse;
  return proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_plans.v1.SubscriptionPlan;
      reader.readMessage(value,proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.subscription_plans.v1.SubscriptionPlan.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionPlan data = 1;
 * @return {!Array<!proto.acompanha.subscription_plans.v1.SubscriptionPlan>}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_plans.v1.SubscriptionPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_plans.v1.SubscriptionPlan, 1));
};


/**
 * @param {!Array<!proto.acompanha.subscription_plans.v1.SubscriptionPlan>} value
 * @return {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse} returns this
*/
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.subscription_plans.v1.SubscriptionPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_plans.v1.SubscriptionPlan}
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.subscription_plans.v1.SubscriptionPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse} returns this
 */
proto.acompanha.subscription_plans.v1.ListSubscriptionPlansResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest;
  return proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.subscription_plans.v1.SubscriptionPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse;
  return proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_plans.v1.SubscriptionPlan;
      reader.readMessage(value,proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_plans.v1.SubscriptionPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPlan data = 1;
 * @return {?proto.acompanha.subscription_plans.v1.SubscriptionPlan}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.subscription_plans.v1.SubscriptionPlan} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_plans.v1.SubscriptionPlan, 1));
};


/**
 * @param {?proto.acompanha.subscription_plans.v1.SubscriptionPlan|undefined} value
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse} returns this
*/
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse} returns this
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_plans.v1.GetSubscriptionPlanResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
monthlyBilledValue: jspb.Message.getFieldWithDefault(msg, 3, 0),
featuresList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
limitsList: jspb.Message.toObjectList(msg.getLimitsList(),
    acompanha_common_v1_common_pb.PlanLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest;
  return proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyBilledValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeatures(value);
      break;
    case 5:
      var value = new acompanha_common_v1_common_pb.PlanLimit;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanLimit.deserializeBinaryFromReader);
      msg.addLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMonthlyBilledValue();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getLimitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      acompanha_common_v1_common_pb.PlanLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 monthly_billed_value = 3;
 * @return {number}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.getMonthlyBilledValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.setMonthlyBilledValue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated string features = 4;
 * @return {!Array<string>}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.getFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.setFeaturesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.addFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.clearFeaturesList = function() {
  return this.setFeaturesList([]);
};


/**
 * repeated acompanha.common.v1.PlanLimit limits = 5;
 * @return {!Array<!proto.acompanha.common.v1.PlanLimit>}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.getLimitsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PlanLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PlanLimit, 5));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PlanLimit>} value
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
*/
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.setLimitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.acompanha.common.v1.PlanLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PlanLimit}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.addLimits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.acompanha.common.v1.PlanLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanRequest.prototype.clearLimitsList = function() {
  return this.setLimitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.subscription_plans.v1.SubscriptionPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse;
  return proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_plans.v1.SubscriptionPlan;
      reader.readMessage(value,proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_plans.v1.SubscriptionPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPlan data = 1;
 * @return {?proto.acompanha.subscription_plans.v1.SubscriptionPlan}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.subscription_plans.v1.SubscriptionPlan} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_plans.v1.SubscriptionPlan, 1));
};


/**
 * @param {?proto.acompanha.subscription_plans.v1.SubscriptionPlan|undefined} value
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse} returns this
*/
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse} returns this
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_plans.v1.CreateSubscriptionPlanResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
monthlyBilledValue: jspb.Message.getFieldWithDefault(msg, 4, 0),
featuresList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
limitsList: jspb.Message.toObjectList(msg.getLimitsList(),
    acompanha_common_v1_common_pb.PlanLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest;
  return proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyBilledValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeatures(value);
      break;
    case 6:
      var value = new acompanha_common_v1_common_pb.PlanLimit;
      reader.readMessage(value,acompanha_common_v1_common_pb.PlanLimit.deserializeBinaryFromReader);
      msg.addLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMonthlyBilledValue();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getLimitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      acompanha_common_v1_common_pb.PlanLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 monthly_billed_value = 4;
 * @return {number}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.getMonthlyBilledValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.setMonthlyBilledValue = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated string features = 5;
 * @return {!Array<string>}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.getFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.setFeaturesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.addFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.clearFeaturesList = function() {
  return this.setFeaturesList([]);
};


/**
 * repeated acompanha.common.v1.PlanLimit limits = 6;
 * @return {!Array<!proto.acompanha.common.v1.PlanLimit>}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.getLimitsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.PlanLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.PlanLimit, 6));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.PlanLimit>} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
*/
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.setLimitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.acompanha.common.v1.PlanLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.PlanLimit}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.addLimits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.acompanha.common.v1.PlanLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanRequest.prototype.clearLimitsList = function() {
  return this.setLimitsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.subscription_plans.v1.SubscriptionPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse;
  return proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_plans.v1.SubscriptionPlan;
      reader.readMessage(value,proto.acompanha.subscription_plans.v1.SubscriptionPlan.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_plans.v1.SubscriptionPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPlan data = 1;
 * @return {?proto.acompanha.subscription_plans.v1.SubscriptionPlan}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.subscription_plans.v1.SubscriptionPlan} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_plans.v1.SubscriptionPlan, 1));
};


/**
 * @param {?proto.acompanha.subscription_plans.v1.SubscriptionPlan|undefined} value
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse} returns this
*/
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse} returns this
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_plans.v1.UpdateSubscriptionPlanResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest;
  return proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest}
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest} returns this
 */
proto.acompanha.subscription_plans.v1.DeleteSubscriptionPlanRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.subscription_plans.v1);
